import { Component } from '@angular/core';

import { MixpanelEvents } from '../../models/mixpanelEvents';
import { PlatformApplications } from '../../models/platformApplications';
import { ServiceFeatures } from '../../models/serviceFeatures';

import { MixpanelService } from '../../services/mixpanel.service';
import { SessionService } from '../../services/session.service';

import { SHARED_MODULES } from '../../../shared.';
import { PhButtonComponent } from '../ph-button/ph-button.component';
import { PhIconComponent } from '../ph-icon/ph-icon.component';

@Component({
    selector: 'app-expired',
    templateUrl: './expired.component.html',
    styleUrls: ['./expired.component.scss'],
	imports: [SHARED_MODULES, PhButtonComponent, PhIconComponent],
    standalone: true
})
export class ExpiredComponent {

	public demoAccess: boolean = false;
	public expiredSubtitle: string = '';
	public expiredTitle: string = '';
	public paymentsAccess: boolean = false;
	public possibilities: Array<{ icon: string, title: string, description: string }> = [];

	constructor(private mixPanelService: MixpanelService, private sessionService: SessionService) {
		this.possibilities.push(
			{
				icon: 'unlimited',
				title: 'HOME.FEATURES_BLOCK.PRODUCTS',
				description: 'EXPIRED.POSSIBILITIES.PRODUCTS'
			},
			{
				icon: 'drawBlock',
				title: 'HOME.FEATURES_BLOCK.RULES_AND_BLOCKS',
				description: 'EXPIRED.POSSIBILITIES.RULES_AND_BLOCKS'
			},
			{
				icon: 'send',
				title: 'HOME.FEATURES_BLOCK.CONTROL',
				description: 'EXPIRED.POSSIBILITIES.EXECUTION'
			},
			{
				icon: 'unlimited',
				title: 'HOME.FEATURES_BLOCK.PLANOGRAMS',
				description: 'EXPIRED.POSSIBILITIES.PLANOGRAMS'
			},
			{
				icon: 'mobile',
				title: 'HOME.FEATURES_BLOCK.MOBILE',
				description: 'EXPIRED.POSSIBILITIES.MOBILE'
			},
			{
				icon: 'barChart',
				title: 'HOME.FEATURES_BLOCK.ANALYTICS',
				description: 'EXPIRED.POSSIBILITIES.ANALYSIS'
			}
		);

		this.paymentsAccess = this.sessionService.hasAccess('ap-payments-and-subscriptions');

		if (this.sessionService.hasFeature(ServiceFeatures.Demo)) {
			this.demoAccess = true;
			this.expiredTitle = 'EXPIRED.DEMO_TITLE';
			this.expiredSubtitle = 'EXPIRED.DEMO_SUBTITLE';
		} else {
			this.expiredTitle = 'EXPIRED.TARIFF_TITLE';

			if (this.paymentsAccess) {
				this.expiredSubtitle = 'EXPIRED.TARIFF_ADMIN_SUBTITLE';
			} else {
				this.expiredSubtitle = 'EXPIRED.TARIFF_SUBTITLE';
			}
		}
	}

	clickBookPresentation(): void {
        this.mixPanelService.trackPage(MixpanelEvents.BookPresentation, { page: 'Expired' });
        this.sessionService.openDemoPresentaionModal();
	}

	clickChoseTariff(): void {
		this.mixPanelService.trackPage(MixpanelEvents.ChooseTariff, { page: 'Expired' });
		window.open(this.sessionService.getExternalLink(PlatformApplications.AdminPanel, '/tariff-plans'), '_blank');
	}

	clickPayTariff(): void {
		this.mixPanelService.trackPage(MixpanelEvents.PayTariff, { page: 'Expired' });
		window.open(this.sessionService.getExternalLink(PlatformApplications.AdminPanel, '/subscriptions'), '_blank');
	}
}